import { render, staticRenderFns } from "./ReceiveItem.vue?vue&type=template&id=36165223&scoped=true"
import script from "./ReceiveItem.vue?vue&type=script&lang=js"
export * from "./ReceiveItem.vue?vue&type=script&lang=js"
import style0 from "./ReceiveItem.vue?vue&type=style&index=0&id=36165223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36165223",
  null
  
)

export default component.exports